import { createContext, useContext } from 'react'
import type { Me } from '../api/types'

export type AuthStatus = 'loading' | 'authenticated' | 'anonymous'

export interface AuthState {
  status: AuthStatus
  user: Me | null
  login(username: string, password: string): Promise<Me>
  logout(): Promise<void>
}

export const AuthContext = createContext<AuthState | null>(null)

export function useAuth(): AuthState {
  const value = useContext(AuthContext)
  if (!value) throw new Error('useAuth must be used inside <AuthProvider>')
  return value
}

export function useUser(): Me {
  const { user } = useAuth()
  if (!user) throw new Error('useUser needs an authenticated user')
  return user
}
